export function removeUndefinedProps<T extends object>(obj: T): T {
  const noUndef = Object.entries(obj).filter(([k, v]) => v !== undefined)
  return Object.fromEntries(noUndef) as T
}
